import { GetSuccessfulTrade } from "@/api/SuccessfulTrade";

const state = {
  GetSuccessfulTrade:{},
  RefuseReceiver:null,
  Detail: [],
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
  INIT_Detail: (state)=>{
    state['Detail'] = [];
  },
  PUS_Detail: (state, data)=>{
    state['Detail'] = state['Detail'].concat(data);
  },
};

const actions = {
  GetSuccessfulTrade({ commit },params) {
    return new Promise((resolve)=>{
      GetSuccessfulTrade( params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetSuccessfulTrade',data:newData});
          commit('PUS_Detail', newData.detail_list)
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      })
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
